import { render } from "./artigosForm.vue?vue&type=template&id=181f3232&scoped=true"
import script from "./artigosForm.vue?vue&type=script&lang=js"
export * from "./artigosForm.vue?vue&type=script&lang=js"

import "./artigosForm.vue?vue&type=style&index=0&id=181f3232&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181f3232"]])

export default __exports__